import { Routes } from '@angular/router';

import { authGuard } from '@core/guard';
import { AuthLayoutComponent } from '@layout/auth-layout/auth-layout.component';
import { ContentLayoutComponent } from '@layout/content-layout/content-layout.component';
import { ApplicationRoleType } from '@data/enum';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/auth/login',
        pathMatch: 'full',
    },
    {
        path: 'auth',
        component: AuthLayoutComponent,
        loadChildren: () => import('@module/auth').then((m) => m.routes),
        canMatch: [authGuard({ requiresAuthentication: false })],
    },

    // ── Authenticated shell ─────────────────────────────────────────
    // Parent guard: any authenticated user. Role restrictions are
    // enforced per-child so shared routes (e.g. /dashboard) are not
    // duplicated across multiple parent groups.
    {
        path: '',
        component: ContentLayoutComponent,
        canMatch: [authGuard({ requiresAuthentication: true })],
        children: [
            // Shared — component renders role-appropriate content
            {
                path: 'dashboard',
                loadChildren: () => import('@module/dashboard').then((m) => m.routes),
            },

            // Super Admin only
            {
                path: 'configurations',
                canMatch: [authGuard({ requiresAuthentication: true, allowedRoles: [ApplicationRoleType.SUPER_ADMIN] })],
                loadChildren: () => import('@module/configurations').then((m) => m.routes),
            },
            {
                path: 'companies',
                canMatch: [authGuard({ requiresAuthentication: true, allowedRoles: [ApplicationRoleType.SUPER_ADMIN] })],
                loadChildren: () => import('@module/company-management').then((m) => m.routes),
            },
            {
                path: 'supplier-verification',
                canMatch: [authGuard({ requiresAuthentication: true, allowedRoles: [ApplicationRoleType.SUPER_ADMIN] })],
                loadChildren: () => import('@module/supplier-verification').then((m) => m.routes),
            },
            {
                path: 'categories',
                canMatch: [authGuard({ requiresAuthentication: true, allowedRoles: [ApplicationRoleType.SUPER_ADMIN] })],
                loadChildren: () => import('@module/category-management').then((m) => m.routes),
            },
            {
                path: 'ideas-occasions',
                canMatch: [authGuard({ requiresAuthentication: true, allowedRoles: [ApplicationRoleType.SUPER_ADMIN] })],
                loadChildren: () => import('@module/ideas-occasions-management').then((m) => m.routes),
            },
            {
                path: 'users',
                canMatch: [authGuard({ requiresAuthentication: true, allowedRoles: [ApplicationRoleType.SUPER_ADMIN] })],
                loadChildren: () => import('@module/user-management').then((m) => m.routes),
            },
            {
                path: 'newsletter-subscribers',
                canMatch: [authGuard({ requiresAuthentication: true, allowedRoles: [ApplicationRoleType.SUPER_ADMIN] })],
                loadChildren: () => import('@module/newsletter-subscribers').then((m) => m.routes),
            },
            {
                path: 'contact-messages',
                canMatch: [authGuard({ requiresAuthentication: true, allowedRoles: [ApplicationRoleType.SUPER_ADMIN] })],
                loadChildren: () => import('@module/contact-messages').then((m) => m.routes),
            },

            // Distributor / Supplier only
            {
                path: 'products',
                canMatch: [authGuard({ requiresAuthentication: true, allowedRoles: [ApplicationRoleType.DISTRIBUTOR_SUPPLIER] })],
                loadChildren: () => import('@module/products').then((m) => m.routes),
            },
            {
                path: 'verification',
                canMatch: [authGuard({ requiresAuthentication: true, allowedRoles: [ApplicationRoleType.DISTRIBUTOR_SUPPLIER] })],
                loadChildren: () => import('@module/verification').then((m) => m.routes),
            },
            {
                path: 'quotes',
                canMatch: [authGuard({ requiresAuthentication: true, allowedRoles: [ApplicationRoleType.DISTRIBUTOR_SUPPLIER] })],
                loadChildren: () => import('@module/quotes').then((m) => m.routes),
            },
        ],
    },

    {
        path: '**',
        redirectTo: '/auth/login',
    },
];
